import * as THREE from 'three';
import { InteractiveStar } from './InteractiveStar.js';

const SKY_RADIUS = 800;

function azAlt(azDeg, altDeg) {
  const az = (azDeg * Math.PI) / 180;
  const alt = (altDeg * Math.PI) / 180;
  const cosAlt = Math.cos(alt);
  return new THREE.Vector3(
    SKY_RADIUS * cosAlt * Math.sin(az),
    SKY_RADIUS * Math.sin(alt),
    -SKY_RADIUS * cosAlt * Math.cos(az),
  );
}

const WANDERER_CARD = `
  <h2>The Wanderer</h2>
  <div class="label">Wanderlust</div>

  <p>The Greek word for "planet" is <em>planētēs</em>. It means <em>wanderer</em>. The first astronomers gave this name to a few points of light because they noticed something: while every other star stayed in fixed patterns, these few drifted across the sky. They moved.</p>

  <p>This star is for the part of you that does the same thing.</p>

  <p>You have lived in three places - Kerala, Bangalore, Seattle - and each time you moved, you chose it. And in between, you just went places. Because you wanted to.</p>

  <p>Some of the places you have visited:</p>

  <div class="friends">
    <div class="friend">Singapore</div>
    <div class="friend">Dubai</div>
    <div class="friend">London</div>
    <div class="friend">Edinburgh</div>
    <div class="friend">Miami</div>
    <div class="friend">Yellowstone</div>
  </div>

  <p>Yellowstone deserves its own line. It is the closest place on Earth that looks like a place <em>not</em> on Earth. Geysers, hot springs, sulfur pools, ground that breathes. You went to the most extraterrestrial corner of your own planet. Of course you did. You like the alien stuff.</p>

  <hr>

  <p>There are more places you have not been to yet.</p>

  <p>Wanderlust is just gravity that hasn't picked a star.</p>
`;

/**
 * The Wanderer - a single interactive star representing Megha's wanderlust
 * (her trait, not her individual trips).
 *
 * Replaces the earlier "Wandering Planets" cluster of 6 separate dots.
 * Six dots for "places she's been" was a list pretending to be a
 * constellation, and it didn't fit the rest of the design where each star
 * is a singular thing.
 *
 * Color: warm honey-amber. Slightly distinct from Sirius's gold but in the
 * same warm family. Honors the wanderer/planet astronomical connection.
 */
export function createWanderer({ onClick }) {
  return new InteractiveStar({
    position: azAlt(255, 50),  // west-southwest, mid-altitude
    color: 0xffb068,
    glowColor: '255, 175, 105',
    scale: 28,
    pulseSpeed: 0.5,
    pulseAmount: 0.05,
    discoveryId: 'wanderer',
    category: 'hobbies',
    cardHTML: WANDERER_CARD,
    onClick,
  });
}
